// Item novo em contrato ATIVO (decisão 09/out/2026): não é criado pelo Editar itens,
// entra pelo Aditivo de itens. Espelha itensNovosEmContratoAtivo do backend: sugere
// só o item simples (fonte manual, sem vínculo); SPXO/patrimônio/vinculado se lançam à mão.
const simples = (i) => (!i.fonte_quantidade || i.fonte_quantidade === 'manual') && (i.id_item_vinculo === null || i.id_item_vinculo === undefined || i.id_item_vinculo === '');

export const novosDoContrato = (itens, idContrato) => (itens || [])
    .filter((i) => i && !i.id && String(i.id_contrato) === String(idContrato));

export const sugestaoAditivoItens = (itens, idContrato) => {
    const novos = novosDoContrato(itens, idContrato);
    const itensNovos = novos.filter(simples).filter((i) => String(i.descricao || '').trim()).map((i) => ({
        descricao: String(i.descricao).trim(),
        codigo: i.codigo || '',
        tipo: i.tipo || 'Serviço',
        grupo: i.grupo || '',
        unidade: i.unidade || 'Mês',
        quantidade_contratada: parseInt(i.quantidade_contratada, 10) || 0,
        quantidade_implantada: Math.max(0, parseInt(i.quantidade_implantada, 10) || 0),
        valor_unitario: i.valor_unitario === '' || i.valor_unitario === undefined ? '' : Number(i.valor_unitario) || 0,
    }));
    return { itens_novos: itensNovos, nao_simples: novos.filter((i) => !simples(i)).length };
};

export const MSG_ITEM_NOVO_ATIVO = 'Contrato ativo: item novo entra por Aditivo de itens, com motivo e data de vigência.';
